import config from 'utils/config';

function isMultiDomain(asset) {
	return (
		(asset.domain_id && config.domain_id !== +asset.domain_id) ||
		asset.multiDomains
	);
}

export function isMultiDomains(domain_ids) {
	return domain_ids.some(d => d !== config.domain_id);
}

export default isMultiDomain;
